import { useNavigate, useLocation } from "react-router-dom";
import { LayoutGrid, Settings, ArrowLeft, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LEGACY_LOGO_URL as LOGO_URL } from "@/lib/api";

const NAV = [
  { to: "/area-riservata", label: "Aree", icon: LayoutGrid, exact: true },
  { to: "/area-riservata/gestione", label: "Gestione", icon: Settings, adminOnly: true },
];

export const AreaLayout = ({ children, title, subtitle, actions }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const isActive = (item) => (item.exact ? location.pathname === item.to : location.pathname.startsWith(item.to));

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-40 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button data-testid="area-back-hub" onClick={() => navigate("/dashboard")} className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 px-2 py-1.5 rounded-md hover:bg-slate-100 transition-all">
              <ArrowLeft className="h-4 w-4" /> Suite
            </button>
            <div className="h-5 w-px bg-slate-200" />
            <img src={LOGO_URL} alt="Assietica" className="h-11 w-auto object-contain" />
            <div className="hidden sm:flex items-center gap-2 leading-tight">
              <Lock className="h-4 w-4 text-brand-blue" />
              <div>
                <div className="font-heading font-semibold text-slate-900">Area Riservata</div>
                <div className="text-[10px] uppercase tracking-widest text-slate-400">Spazi dedicati a clienti e convenzioni</div>
              </div>
            </div>
          </div>
          <span className="text-xs text-slate-500 hidden md:block">{user?.email}</span>
        </div>
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 flex gap-1 overflow-x-auto">
          {NAV.filter((n) => !n.adminOnly || user?.role === "admin").map((n) => {
            const Icon = n.icon;
            const active = isActive(n);
            return (
              <button key={n.to} data-testid={`area-nav-${n.label.toLowerCase()}`} onClick={() => navigate(n.to)}
                className={`flex items-center gap-2 px-3 py-2.5 text-sm border-b-2 transition-all whitespace-nowrap ${active ? "border-brand-blue text-brand-blue font-medium" : "border-transparent text-slate-500 hover:text-slate-900"}`}>
                <Icon className="h-4 w-4" /> {n.label}
              </button>
            );
          })}
        </nav>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        {(title || actions) && (
          <div className="flex items-start justify-between mb-6 gap-4 flex-wrap">
            <div>
              {subtitle && <p className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-1">{subtitle}</p>}
              {title && <h1 className="font-heading text-2xl sm:text-3xl font-medium text-slate-900 tracking-tight">{title}</h1>}
            </div>
            {actions}
          </div>
        )}
        {children}
      </main>
    </div>
  );
};
